// Words for a card's numbers and codes: the period it covers in the viewer's language, and the
// names of lexicon entries. Grape and region names are proper nouns and are not translated.
import { grapeByCode, periodRange, regionByCode, type CardPeriod } from "@proef/domain";
import type { Locale } from "../i18n";

/** The week number of an ISO week key such as `2026-W42`. */
export function weekNumber(key: string): number {
  return Number(key.slice(key.indexOf("W") + 1));
}

/** "12–18 Oct" for a week, "October 2026" for a month; always the UTC dates the card was built on. */
export function periodLabel(period: CardPeriod, key: string, locale: Locale): string {
  const range = periodRange(period, key);
  if (range === undefined) return key;
  if (period === "month") {
    const text = new Intl.DateTimeFormat(locale, {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    }).format(range.start);
    return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
  }
  // The range's end is exclusive; the last day shown is the Sunday.
  const lastDay = new Date(range.end.getTime() - 1);
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
  }).formatRange(range.start, lastDay);
}

export function grapeLabel(code: string): string {
  return grapeByCode(code)?.name ?? code;
}

export function regionLabel(code: string): string {
  return regionByCode(code)?.name ?? code;
}

export function badgeLabelKey(id: string): string {
  return `social.card.badge.${id}`;
}
